//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import loginFun from "@/utils/cc-webapp/login.js";
  export default {
    data() {
      return {
        tabActive: 2,
        iconAll: {
          iconSetting: require("@/assets/image/icon/icon_setting.png"),
          iconEdit: require("@/assets/image/icon/icon_edit_depict_1.png"),
          iconMybook: require("@/assets/image/icon/icon_myBook.png"),
          iconMycollection: require("@/assets/image/icon/icon_myCollect.png"),
          iconMycours: require("@/assets/image/icon/icon_myCourse.png"),
          iconMygold: require("@/assets/image/icon/icon_myGold.png"),
          iconMylisten: require("@/assets/image/icon/icon_myListen.png"),
          iconMyvip: require("@/assets/image/icon/icon_myVip.png"),
          //iconAvatar: require("@/assets/image/icon/icon_avatar.png"),
          iconAvatar: require("@/assets/image/icon/userphotobg.jpg"),
          // iconCode: require("@/assets/image/icon/code.png"), //二维码
          iconCode: require("@/assets/image/icon/icon_vip.png"),
          iconCoupon: require("@/assets/image/icon/icon_coupon.png"),
          iconRecord: require("@/assets/image/icon/icon_record.png"),
          iconDownLoad: require("@/assets/image/icon/icon_download.png")
        },
        userInfo: {},
        isLogin: false,
        learnTime: "",
        isHaveSession: false, //存在Session ，包含匿名用户
        showVip: false,
        exceed1_2: false, //当前版本号是否大于1.2
        userId: "",
        userPoint: '',
        thirdPartToken: localStorage.getItem('thirdPartToken')
      };
    },
    methods: {
      //检验session是否过期
      getData() {
       // console.log(localStorage.getItem('app_session'))
        this.LOGIN2.getSession("no login")
          .then(session => {
            console.log("session", session);
            // 有session
            this.userId = session.userId;
            this.userInfo = session.userInfo;
            this.isLogin = true;
            this.getInfo(this.thirdPartToken);
          })
          .catch(err => {
            console.log("沒有session", err);
            this.userInfo = "";
            this.isLogin = false;
          });

      },
      //获取个人信息
      getInfo(session){
        let postD = {
          params : session
        }
        this.GLOBAL_.ccRequest.doSessionAxios(this.CONFIG.USER.GETUSERINFO, postD, "POST","no login")
          .then(res => {
            console.log('會員获取积分',res)
            this.userInfo = res;
            this.isLogin = true;
            this.userPoint = res.extraDataJson.userPointAvailable
            this.$forceUpdate();
          })
          .catch(err => {
            let res = err.response;
            // console.log(err);
            if(err.data){
              if (res.data.code == 401) {
                this.isLogin = false;
                localStorage.removeItem('app_session');
                this.$forceUpdate();
              } else {
                this.$toast.text(res.data.message);
              }
            }

          });
      },
      //執行登入
      gotopage(obj) {
        // return
        if(this.isLogin){
          obj.router = this.$router;
          obj.path = this.UTILS.splitUrl(obj.path);
          this.GLOBAL_.ccApp.openTo(obj);
        }else if(obj.path == 'personal'){
          let obj = {
            router: this.$router,
            path: this.UTILS.splitUrl("login")
          };
          this.GLOBAL_.ccApp.openTo(obj);
        }else{
          this.$toast.text(this.$t('ME_LANG.tipsLogin'));
          let obj = {
              router: this.$router,
              path: this.UTILS.splitUrl("login")
          };
          setTimeout(() => {
            this.$toast.close();
            this.GLOBAL_.ccApp.openTo(obj);
          }, 500);
        }
      },
      //点击登录时
      goLogin() {
        //打開登入界面
        let obj = {
          router: this.$router,
          path: this.UTILS.splitUrl("login")
        };
        this.GLOBAL_.ccApp.openTo(obj);
      },
      //存储登入信息
      saveLoginSession(res) {
        let obj = res.data.session;
        obj["userInfo"] = {
          email: res.data.userInfo.email,
          id: res.data.userInfo.id,
          nickname: res.data.userInfo.nickname
        };

        // localStorage.setItem('app_session', JSON.stringify(obj));
        loginFun.saveLoginSession(obj);
      },
      //退出登录
      onlogout(){
        this.GLOBAL_.ccRequest.doSessionAxios(this.CONFIG.USER.LOGOUT, {}, "POST","no login")
          .then(res => {
            console.log('退出',res)
            this.LOGIN.returnLogin();
            this.$router.go(0)
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    mounted() {
      this.getData();
    }
  };



// WEBPACK FOOTER //
// ./src/pages/me/my.vue